import type { FeedItem as FeedItemType } from '@/hooks/useNewsFeed'
import { AnnouncementCard } from './AnnouncementCard'
import { NewsCard } from './NewsCard'

type Props = { item: FeedItemType }

export function FeedItem({ item }: Props) {
  if (item.type === 'announcement') return <AnnouncementCard item={item} />
  return <NewsCard item={item} />
}
